class ProductForm extends HTMLElement {
  connectedCallback() {
    this.form = this.querySelector('form');
    this.variantInput = this.querySelector('[name="id"]');
    this.price = this.querySelector('[data-product-price]');
    this.button = this.querySelector('[name="add"]');
    this.data = JSON.parse(this.querySelector('[type="application/json"]').textContent);
    const qty = this.querySelector('.qty-stepper');
    const slot = this.querySelector('[data-quantity-slot]');
    if (qty && slot) slot.append(qty);
    this.querySelectorAll('input[type="radio"]').forEach(input => input.addEventListener('change', () => this.update()));
    this.form?.addEventListener('submit', event => this.add(event));
    this.update();
  }
  update() {
    const groups = [...this.querySelectorAll('[data-option]')];
    const options = groups.map(group => group.querySelector('input:checked')?.value);
    const variant = this.data.find(item => item.options.every((option, index) => option === options[index]));
    if (!variant) return;
    groups.forEach(group => {
      const checked = group.querySelector('input:checked');
      const selected = group.querySelector('[data-selected-option]');
      if (checked && selected) selected.textContent = checked.dataset.displayValue || checked.value;
    });
    if (this.variantInput) this.variantInput.value = variant.id;
    if (this.price) this.price.innerHTML = this.money(variant.price) + (variant.compare_at_price > variant.price ? ` <s>${this.money(variant.compare_at_price)}</s>` : '');
    this.button.disabled = !variant.available;
    this.button.querySelector('span').textContent = variant.available ? 'Add to Cart' : 'Sold out';
    document.querySelectorAll('[data-sticky-price]').forEach(element => element.textContent = this.money(variant.price));
    document.querySelectorAll('[data-sticky-add]').forEach(element => element.disabled = !variant.available);
    const colorGroup = groups.find(group => /color|colour|цвет/i.test(group.querySelector('legend')?.textContent || ''));
    this.syncGallery(colorGroup?.querySelector('input:checked')?.value, variant);
  }
  showMedia(target) {
    if (!target) return;
    document.querySelectorAll('[data-gallery-thumb]').forEach(thumb => thumb.classList.toggle('active', thumb === target));
    document.querySelectorAll('[data-gallery-slide]').forEach(slide => {
      const active = String(slide.dataset.mediaId) === String(target.dataset.mediaId);
      slide.hidden = !active;
      slide.classList.toggle('active', active);
      if (!active) slide.querySelectorAll('video').forEach(video => video.pause());
    });
  }
  syncGallery(color, variant) {
    const thumbs = [...document.querySelectorAll('[data-gallery-thumb]')];
    if (!thumbs.length) return;
    const key = (color || '').toLowerCase().trim().replace(/[^a-z0-9а-яё]+/gi, '-').replace(/^-|-$/g, '');
    const matches = thumbs.filter(thumb => thumb.dataset.galleryColor === key);
    thumbs.forEach(thumb => thumb.hidden = matches.length ? !(thumb.dataset.galleryColor === key || !thumb.dataset.galleryColor) : false);
    const mediaId = variant?.media_id || variant?.featured_media?.id || variant?.featured_image?.id;
    const target = matches.find(thumb => String(thumb.dataset.mediaId) === String(mediaId)) || matches[0] || thumbs.find(thumb => String(thumb.dataset.mediaId) === String(mediaId)) || thumbs.find(thumb => !thumb.hidden);
    this.showMedia(target);
  }
  money(cents) {
    return new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: window.Shopify?.currency?.active || 'USD' }).format(cents / 100);
  }
  async add(event) {
    event.preventDefault();
    if (this.button.disabled) return;
    this.button.classList.add('loading');
    try {
      const response = await fetch(window.Shopify.routes.root + 'cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(this.form) });
      if (!response.ok) throw new Error();
      const cart = await fetch(window.Shopify.routes.root + 'cart.js').then(item => item.json());
      document.querySelectorAll('[data-cart-count]').forEach(element => element.textContent = cart.item_count);
      if (this.dataset.afterAdd === 'checkout') {
        window.location.assign(window.Shopify.routes.root + 'checkout');
        return;
      }
      this.button.querySelector('span').textContent = 'Added ✓';
      await refreshCartDrawer();
      openCartDrawer();
      setTimeout(() => this.button.querySelector('span').textContent = 'Add to Cart', 1300);
    } catch (_) { this.form.submit(); }
    finally { this.button.classList.remove('loading'); }
  }
}
customElements.define('product-form', ProductForm);

document.addEventListener('click', event => {
  if (event.target.closest('[data-menu-toggle]')) document.body.classList.toggle('menu-open');
  if (event.target.closest('[data-search-toggle]')) {
    const drawer = document.querySelector('[data-search-drawer]');
    drawer.hidden = !drawer.hidden;
    if (!drawer.hidden) drawer.querySelector('input').focus();
  }
  const thumb = event.target.closest('[data-gallery-thumb]');
  if (thumb) document.querySelector('product-form')?.showMedia(thumb);
  const minus = event.target.closest('[data-qty-minus]');
  const plus = event.target.closest('[data-qty-plus]');
  if (minus || plus) {
    const input = (minus || plus).parentElement.querySelector('input');
    input.value = Math.max(1, Number(input.value || 1) + (plus ? 1 : -1));
  }
  const wishlist = event.target.closest('[data-wishlist]');
  if (wishlist) {
    const key = 'nightwell_wishlist';
    const items = new Set(JSON.parse(localStorage.getItem(key) || '[]'));
    items.has(wishlist.dataset.productId) ? items.delete(wishlist.dataset.productId) : items.add(wishlist.dataset.productId);
    localStorage.setItem(key, JSON.stringify([...items]));
    wishlist.classList.toggle('active', items.has(wishlist.dataset.productId));
    wishlist.textContent = items.has(wishlist.dataset.productId) ? '♥' : '♡';
  }
  if (event.target.closest('[data-size-guide-open]')) document.querySelector('[data-size-guide-modal]').hidden = false;
  if (event.target.closest('[data-size-guide-close]') || event.target.matches('[data-size-guide-modal]')) document.querySelector('[data-size-guide-modal]').hidden = true;
});

document.querySelectorAll('[data-wishlist]').forEach(button => {
  const items = new Set(JSON.parse(localStorage.getItem('nightwell_wishlist') || '[]'));
  button.classList.toggle('active', items.has(button.dataset.productId));
  button.textContent = items.has(button.dataset.productId) ? '♥' : '♡';
});
document.querySelectorAll('[data-sticky-add]').forEach(button => button.addEventListener('click', () => document.querySelector('product-form [name="add"]')?.click()));

function openCartDrawer() {
  const drawer = document.querySelector('[data-cart-drawer]');
  const overlay = document.querySelector('[data-cart-overlay]');
  if (!drawer || !overlay) return;
  drawer.classList.add('open');
  drawer.setAttribute('aria-hidden', 'false');
  overlay.hidden = false;
  document.body.style.overflow = 'hidden';
}

function closeCartDrawer() {
  const drawer = document.querySelector('[data-cart-drawer]');
  const overlay = document.querySelector('[data-cart-overlay]');
  drawer?.classList.remove('open');
  drawer?.setAttribute('aria-hidden', 'true');
  if (overlay) overlay.hidden = true;
  document.body.style.overflow = '';
}

async function refreshCartDrawer() {
  try {
    const html = await fetch(`${window.Shopify.routes.root}cart?section_id=cart-drawer`).then(response => response.text());
    const documentFragment = new DOMParser().parseFromString(html, 'text/html');
    const nextDrawer = documentFragment.querySelector('[data-cart-drawer]');
    const nextOverlay = documentFragment.querySelector('[data-cart-overlay]');
    if (nextDrawer) document.querySelector('[data-cart-drawer]')?.replaceWith(nextDrawer);
    if (nextOverlay) document.querySelector('[data-cart-overlay]')?.replaceWith(nextOverlay);
  } catch (_) {}
}

document.addEventListener('click', event => {
  const open = event.target.closest('[data-cart-open]');
  if (open) { event.preventDefault(); openCartDrawer(); }
  if (event.target.closest('[data-cart-close]') || event.target.matches('[data-cart-overlay]')) closeCartDrawer();
  const tab = event.target.closest('[data-drawer-tab]');
  if (tab) {
    document.querySelectorAll('[data-drawer-tab]').forEach(button => button.classList.toggle('active', button === tab));
    document.querySelectorAll('[data-drawer-panel]').forEach(panel => panel.classList.toggle('active', panel.dataset.drawerPanel === tab.dataset.drawerTab));
  }
  if (event.target.closest('[data-filter-toggle]')) document.querySelector('[data-filters]')?.classList.add('open');
  if (event.target.closest('[data-filter-close]')) document.querySelector('[data-filters]')?.classList.remove('open');
  const gridButton = event.target.closest('[data-grid-columns]');
  if (gridButton) {
    const columns = gridButton.dataset.gridColumns;
    const grid = document.querySelector('[data-product-grid]');
    if (grid) grid.style.gridTemplateColumns = `repeat(${columns}, minmax(0, 1fr))`;
    document.querySelectorAll('[data-grid-columns]').forEach(button => button.classList.toggle('active', button === gridButton));
  }
});
